import type {
  PermissionMode,
  PermissionName,
  PermissionStatusMap,
} from '@heidi/agents/contracts';
import { checkPermission } from '../api/permission-bridge';
import { requiredPermissions } from '../matrix';
import { deriveMissingPermissions } from './derive-missing-permissions';

export const emptyPermissionStatusMap = (): PermissionStatusMap => ({
  screen_recording: 'unknown',
  input_monitoring: 'unknown',
  accessibility: 'unknown',
});

export const readPermissionStatuses = async (
  permissions: readonly PermissionName[]
): Promise<PermissionStatusMap> => {
  const entries = await Promise.all(
    permissions.map(
      async (permission) => [permission, await checkPermission(permission)] as const
    )
  );
  return {
    ...emptyPermissionStatusMap(),
    ...Object.fromEntries(entries),
  };
};

export const checkPermissionsQuiet = async (
  mode: PermissionMode
): Promise<PermissionName[]> => {
  const required = requiredPermissions(mode);
  const statuses = await readPermissionStatuses(required);
  return deriveMissingPermissions(required, statuses);
};
